// extracted by mini-css-extract-plugin
export default {"container":"DecodedBanner-module--container--BiS7S","title":"DecodedBanner-module--title--nU7W-","description":"DecodedBanner-module--description--NgxAY"};